import React from 'react';
import { motion } from 'framer-motion';
interface NavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
const tabs = [{
  id: 'about',
  label: 'About Us'
}, {
  id: 'services',
  label: 'Services'
}, {
  id: 'aesthetics',
  label: 'Medical Aesthetics'
}, {
  id: 'membership',
  label: 'Membership'
}, {
  id: 'contact',
  label: 'Contact Us'
}, {
  id: 'login',
  label: 'Login'
}];
export function Navigation({
  activeTab,
  onTabChange
}: NavigationProps) {
  return <motion.nav className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/95 backdrop-blur-sm border-b border-zinc-800" initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} data-id="element-318">
      <div className="px-6 py-6 max-w-[2000px] mx-auto relative flex items-center justify-center" data-id="element-319">
        {/* Logo - Absolute positioned to left */}
        <button onClick={() => onTabChange('home')} className="absolute left-6 text-white text-2xl font-serif tracking-tight hover:text-zinc-300 transition-colors" style={{
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-320">
          NAD+
        </button>

        {/* Tabs - Centered */}
        <div className="hidden lg:flex space-x-8 xl:space-x-12 relative" data-id="element-321">
          {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`text-xs tracking-[0.15em] uppercase font-medium transition-colors relative pb-2 whitespace-nowrap ${activeTab === tab.id ? 'text-white' : 'text-zinc-400 hover:text-white'}`} data-id="element-322">
              {tab.label}
              {activeTab === tab.id && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-px bg-white" transition={{
            type: 'spring',
            stiffness: 380,
            damping: 30
          }} data-id="element-323" />}
            </button>)}
        </div>
      </div>
    </motion.nav>;
}